import {CategoryBudget} from "../../budget";

const setCarryover = (categoryBudget: CategoryBudget, carryover: boolean) => {
    return {
        ...categoryBudget,
        carryover: carryover
    };
}

export default setCarryover;